import React from 'react';
import { Route } from 'react-router-dom';
import TodoPage from './TodoPage';
export const routes = [<Route key={0} path="/todos" component={TodoPage} />];
